import { isNumeric } from '../../../js/app/react/validators';

export const amountValidator = amount => () =>
  !isNumeric(amount) || +amount <= 0 ? ['Please specify an estimated amount'] : [];

export const descriptionValidator = (itemDescription, largePurchaseGoals, goalId) => () => {
  if (!itemDescription || itemDescription.length === 0) {
    return ['Please specify a description'];
  }

  if (
    largePurchaseGoals &&
    largePurchaseGoals
      .filter(({ Id }) => Id !== goalId)
      .some(({ Name }) => Name === itemDescription)
  ) {
    return ['This goal already exists. Please enter a unique name.'];
  }

  return [];
};

export const yearValidator = (year, options) => () =>
  options.indexOf(year && year.toString()) < 0 ? ['Please specify a valid purchase year.'] : [];
